import { useState, useEffect, useCallback } from 'react'
import Auth from '../api/auth'
import { pathOr } from 'ramda'
import { ls } from '@iqueue/ui-kit'

let alreadyFetched = false

export default function usePermissions() {
  const [permissions, setPermissions] = useState(ls('permissions') || {})
  const [auth, setAuth] = useState(ls('account'))
  const [tree, setTree] = useState(auth?.nodes || [])

  const mergePermissions = useCallback((nodes) => {
    return nodes.reduce((acc, node) => {
      const nodePermissions = pathOr({}, ['permissions'], node)
      for (const [key, value] of Object.entries(nodePermissions)) {
        if (!acc[key]) {
          acc[key] = [...value]
        } else {
          acc[key] = [...new Set([...acc[key], ...value])]
        }
      }
      return acc
    }, {})
  }, [])

  const getPermissions = useCallback(async () => {
    if (alreadyFetched) return

    try {
      const res = await Auth.getMe('v1/auth/get-me')

      const allPermissions = mergePermissions(res.nodes || [])

      setPermissions(allPermissions)
      ls('permissions', allPermissions)

      setTree(res.nodes || [])
      setAuth(res)
      ls('account', res)

      alreadyFetched = true
    } catch (error) {
      console.error(error)
      return [
        {
          id: 5,
          title: 'Auth',
          route: 'auth-form',
          icon: 'person',
        },
      ]
    }
  }, [])

  useEffect(() => {
    getPermissions().catch((err) => console.error(err))
  }, [getPermissions])

  return {
    permissions,
    tree,
    auth,
  }
}
